import { render, staticRenderFns } from "./host-carmanage.vue?vue&type=template&id=971989c0&scoped=true&"
import script from "./host-carmanage.vue?vue&type=script&lang=js&"
export * from "./host-carmanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971989c0",
  null
  
)

export default component.exports